module.exports = __webpack_public_path__ + "static/media/04_MLPS-2.0-S-14.0-0 1.c0df554b.png";